import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a0ff64a"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Cidade favorita ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Vamos definir sua cidade favorita, assim podemos filtrar as melhores ofertas e preços perto de você. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Loja favorita ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" E finalmente, vamos definir sua loja favorita, assim podemos filtraro que temos de melhor perto de você. ")
const _hoisted_5 = { class: "font-poppins-light font-12 red" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Avançar ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_radio = _resolveComponent("ion-radio")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_radio_group = _resolveComponent("ion-radio-group")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_footer = _resolveComponent("ion-footer")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          (_ctx.step==1)
            ? (_openBlock(), _createBlock(_component_ion_grid, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-poppins font-20",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_1
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-light font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_radio_group, {
                    modelValue: _ctx.selectCidade,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectCidade) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            id: "product_size"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojas, (cidade, index) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  lines: "none",
                                  value: 'cidade_'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-no-margin font-poppins" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(cidade[0].cidade_loja), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_radio, {
                                      slot: "start",
                                      value: cidade
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.step==2)
            ? (_openBlock(), _createBlock(_component_ion_grid, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_row, { class: "ion-align-items-end" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_col, {
                        class: "font-poppins font-20",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_col, {
                        class: "font-poppins-light font-15",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_4
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_radio_group, {
                    modelValue: _ctx.selectLoja,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectLoja) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_row, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_col, {
                            size: "12",
                            id: "product_size"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectCidade, (cidade, index) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  lines: "none",
                                  value: 'loja_'+index
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_label, { class: "ion-no-margin font-poppins" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(cidade.nome_loja) + " ", 1),
                                        _createElementVNode("span", _hoisted_5, _toDisplayString(" "+cidade.bairro_loja), 1)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_radio, {
                                      slot: "start",
                                      value: cidade
                                    }, null, 8, ["value"])
                                  ]),
                                  _: 2
                                }, 1032, ["value"]))
                              }), 256))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_ion_footer, { class: "ion-no-border" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_col, {
                class: "ion-text-center font-raleway",
                size: "2"
              }),
              (!_ctx.isLast)
                ? (_openBlock(), _createBlock(_component_ion_col, {
                    key: 0,
                    class: "ion-text-center",
                    size: "8"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_button, {
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goto())),
                        color: "jauserve",
                        size: "large",
                        expand: "block"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}